// Substitui o pacote "react-responsive-picture" (peer dep presa ao React 15/16).
// Reimplementação local com o mesmo comportamento/API do componente <Picture>.
const TRANSPARENT_GIF =
  "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

function renderSources(sources) {
  if (sources == null) {
    return null;
  }

  return sources.map((source, index) => {
    if (source.srcSet == null) {
      return null;
    }

    return (
      <source
        key={`sources-${index}`}
        srcSet={source.srcSet}
        media={source.media}
        type={source.type}
      />
    );
  });
}

function renderImage(props, skipSizes = false) {
  const { alt = "", src = TRANSPARENT_GIF, sizes, ...rest } = props;
  const sizesProp = skipSizes ? null : { sizes };

  return <img alt={alt} srcSet={src} {...sizesProp} {...rest} />;
}

export function Picture({ sources, ...rest }) {
  if (sources != null) {
    return (
      <picture>
        {renderSources(sources)}
        {renderImage(rest, true)}
      </picture>
    );
  }

  return renderImage(rest);
}

export default Picture;
